export default __webpack_public_path__ + "static/ballet-west-II-6524b2aebf9be7c5b877864ef7faef84.jpg";